<h3>Profile</h3>
<p-divider></p-divider>
<div *ngIf="contentLayout.currentlyAuthorizedUserService.user$ | async as user" class="font-medium">
  Hello, {{ user.firstName + ' ' + user.lastName }}!
</div>
<a pButton pRipple type="button" label="Profile" routerLink="/account/" class="p-button w-full mt-5">
  <div><i class="fa-solid fa-user-gear"></i></div>
</a>
<a pButton pRipple type="button" label="Logout" (click)="onLogoutClick()" class="p-button-text w-full mt-5">
  <div><i class="fa-solid fa-arrow-right-from-bracket"></i></div>
</a>
